import { Alert } from '@zillow/constellation-10';

import { US_STATES_LABEL_MAP } from '@zg-rentals/states-territories';

import { useOwnershipVerificationState } from '../../../../../../hooks/queries/useOwnershipVerification';

export type OwnershipVerificationWarningProps = {
  listingAlias: string;
  /** Caller owns the rollout flag, and must hold the lookup until the listing has a `forRentBy`. */
  enabled: boolean;
  stateCode: string | undefined;
};

/**
 * Tells the landlord on the review page that verification is coming. Reads the same query the wizard
 * gates the verify step on, so the warning and that step cannot disagree about whether it applies.
 */
const OwnershipVerificationWarning = ({ listingAlias, enabled, stateCode }: OwnershipVerificationWarningProps) => {
  const { shouldShowVerificationStep } = useOwnershipVerificationState({ listingAlias, enabled });

  if (!shouldShowVerificationStep) return null;

  // Not hardcoded to Alabama: the backend setting is per-state and designed to add more.
  const stateName = US_STATES_LABEL_MAP[stateCode as keyof typeof US_STATES_LABEL_MAP];

  return (
    <Alert tone="warning" data-testid="OwnershipVerificationWarning" css={{ marginBottom: '400' }}>
      {stateName ? `${stateName} law requires` : 'State law requires'} identity and ownership verification before you
      can publish this listing. You’ll complete those steps on the next page.
    </Alert>
  );
};

export default OwnershipVerificationWarning;
